import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { FormSpacer } from "@saleor/components/FormSpacer";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
import { FetchMoreProps } from "@saleor/types";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    card: {
      overflow: "visible"
    },
    cardSubtitle: {
      fontSize: "1rem",
      marginBottom: theme.spacing(0.5)
    },
    label: {
      marginBottom: theme.spacing(0.5)
    }
  }),
  { name: "ProductVariantCornermarks" }
);

interface ProductVariantCornermarksProps {
  cornermarks?: SingleAutocompleteChoiceType[];
  cornermarkInputDisplayValue: string;
  data: {
    cornermark: string;
  };
  disabled: boolean;
  errors: ProductErrorFragment[];
  fetchCornermarks: (query: string) => void;
  fetchMoreCornermarks: FetchMoreProps;
  onCornermarkChange: (event: ChangeEvent) => void;
}

const ProductVariantCornermarks: React.FC<ProductVariantCornermarksProps> = props => {
  const {
    cornermarks,
    cornermarkInputDisplayValue,
    data,
    disabled,
    errors,
    fetchCornermarks,
    fetchMoreCornermarks,
    onCornermarkChange
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const formErrors = getFormErrors(["cornermark"], errors);

  return (
    <Card className={classes.card}>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Cornermark",
          description: "section header"
        })}
      />
      <CardContent>
        <SingleAutocompleteSelectField
          displayValue={cornermarkInputDisplayValue}
          error={!!formErrors.cornermark}
          helperText={getProductErrorMessage(formErrors.cornermark, intl)}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Cornermark"
          })}
          choices={disabled ? [] : cornermarks}
          thumbnail={true}
          name="cornermark"
          value={data.cornermark}
          onChange={onCornermarkChange}
          fetchChoices={fetchCornermarks}
          emptyOption={true}
          data-test="cornermark"
          {...fetchMoreCornermarks}
        />
        <FormSpacer />
      </CardContent>
    </Card>
  );
};
ProductVariantCornermarks.displayName = "ProductVariantCornermarks";
export default ProductVariantCornermarks;
